import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/dining/Workspace.tsx");
